import type { Meta, StoryObj } from "@storybook/react";

import { fakeAvatarCardProps } from "@/__mocks__/mockBaseTypes";
import type { GroupClassSessionCardProps } from "@/ui/components/groupClasses/series/session/GroupClassSessionCard";
import GroupClassSessionCard from "@/ui/components/groupClasses/series/session/GroupClassSessionCard";

const hostOne = fakeAvatarCardProps({
  userType: "provider",
});
const hostTwo = fakeAvatarCardProps({
  userType: "provider",
});

const StoryMeta: Meta<GroupClassSessionCardProps> = {
  title: "Components/Group Classes/Session Card",
  component: GroupClassSessionCard,
  argTypes: {
    onPress: { action: "pressed" },
    sessionCount: { control: "number" },
    timeRange: { control: "text" },
    title: { control: "text" },
  },
  args: {
    sessionCount: 16,
    timeRange: "4 - 4:30pm",
    title: "Every Monday",
  },
};

type Story = StoryObj<GroupClassSessionCardProps>;

const MultipleHosts: Story = {
  args: {
    hosts: [hostOne, hostTwo],
  },
};

const SingleHost: Story = {
  args: {
    hosts: [hostOne],
  },
};

const NoHosts: Story = {};

export { MultipleHosts, NoHosts, SingleHost };
export default StoryMeta;
